import { all } from "redux-saga/effects";
import appSaga from "./Containers/App/saga";
import clientSaga from "./Containers/Client/saga";
import addPost from "./Containers/PostContainer/saga";
import confirmationSaga from "./Pages/Confirmation/saga";
import homeSaga from "./Pages/Home/saga";
import loginSaga from "./Pages/Login/saga"
import registerSaga from "./Pages/Register/saga";
import settingsSaga from "./Pages/Settings/saga";
import exploreSaga from "./Pages/Explore/saga";

export default function* rootSaga() {
    yield all([
        appSaga(),
        clientSaga(),
        loginSaga(),
        registerSaga(),
        addPost(),
        homeSaga(),
        settingsSaga(),
        confirmationSaga(),
        exploreSaga(),
    ])
}